import moment from 'moment';
import momentTZ from 'moment-timezone';

const tz = 'America/New_York';

const groupByDays = input => {
  const output = input.reduce(function (acc, date) {

    const _date = momentTZ(date).tz(tz);
    const formattedDate = _date.format('YYYY-MM-DD');
    if (typeof acc[formattedDate] === 'undefined') {
      acc[formattedDate] = [];
    }

    acc[formattedDate].push(_date);
    return acc;

  }, {});
  return output;
};

const groupByWeeks = (input) => {
  const output = input.reduce(function (acc, date) {

    const yearWeek = `${ moment(date).year() }-W${ moment(date).week() + 1 }`;

    // check if the week number exists
    if (typeof acc[yearWeek] === 'undefined') {
      acc[yearWeek] = [];
    }

    acc[yearWeek].push(momentTZ(date).tz(tz));

    return acc;

  }, {});
  return output;
};

const groupByMonths = (input) => {
  const output = input.reduce(function (acc, date) {

    //PUT MONTH NAME INSTEAD OF INDEX!!!
    const yearMonth = `${ moment(date).year() }-${ moment(date).format('MMM')}`;

    if (typeof acc[yearMonth] === 'undefined') {
      acc[yearMonth] = [];
    }

    acc[yearMonth].push(momentTZ(date).tz(tz));

    return acc;

  }, {});
  return output;
};

export const transformDates = (input) => {
  let type = 'days';
  if (input.length > 30 && input.length < 7 * 30) {
    type = 'weeks';
  } else if (input.length > 7 * 30) {
    type = 'months';
  }

  switch (type) {
    case 'weeks':
      return groupByWeeks(input);
    case 'months':
      return groupByMonths(input);
    case 'days':
    default:
      return groupByDays(input);
  }

};





// WEBPACK FOOTER //
// ./src/utils/time_utils.js